export default {
    INDEX_BANNER:"/api/home/getSlideShow", //首页轮播图接口
    INDEX_MODEL:"/api/home/getModel", //首页流程介绍（六个）
    INDEX_DATALIST:"/api/home/getDataList", //获取首页其他数据 影视信息 关于我们 底部信息log 二维码等图片
    INDEX_STATISTICS:"/api/home/statistics", //统计接口 每次访问首页调用一次,不处理返回值
    INDEX_FLOW:"/api/data/getFlow", //获取流程列表
    INDEX_MOVIELIST:"/api/data/getMovieList", //获取影视列表 获取影视信息列表 type 1作品 2电影 3 电视剧 4 网络电影 5网剧  offset 页数 limit 步进
    INDEX_NEWS:"/api/home/getNews", //新闻动态
    INDEX_RECORD:"/api/home/getRecords", //获奖履历
    INDEX_INFO:"/api/home/company/1", //公司简介
    INDEX_CONTACT:"/api/home/company/2", //联系我们
	INDEX_ENVIRIONMENT:"/api/home/environment", //工作环境
	INDEX_CULTURE:"/api/home/getCultural", //文化信息
	INDEX_INVITE:"/api/data/getInviteList", //招聘信息
	
}


// WEBPACK FOOTER //
// ./src/api/path.js